import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcAnchoringdownFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "25",
    fill: "none",
    viewBox: "0 0 24 25",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.222 5.003a1.1 1.1 0 0 1 1.556 0L12 10.226l5.222-5.223a1.1 1.1 0 1 1 1.556 1.556l-6 6a1.1 1.1 0 0 1-1.556 0l-6-6a1.1 1.1 0 0 1 0-1.556",
    clipRule: "evenodd",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.222 13.004a1.1 1.1 0 0 1 1.556 0L12 18.226l5.222-5.222a1.1 1.1 0 1 1 1.556 1.555l-6 6a1.1 1.1 0 0 1-1.556 0l-6-6a1.1 1.1 0 0 1 0-1.555",
    clipRule: "evenodd"
  }));
}
var IcAnchoringdownFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcAnchoringdownFill));

export { IcAnchoringdownFill as I };
